import React, { useEffect, useState } from "react";
import styles from './MarketingScreenNew.module.css'
import style from "./MarketingScreen.module.css";
import MarketingScreenBanner from "./MarketingScreenBanner";
import MarketingWhyReadProWhatsapp from "./MarketingWhyReadProWhatsapp";
import MarketingBussinessPlans from "./MarketingBussinessPlans";
import MarketingTestimonials from "./MarketingTestimonials";
import FaqLayout from "../../Components/FaqLayout/FaqLayout";
import { whatsappMarketingFaqs } from "./MarketingFaqData";
import CenteredPopUp from "../../Components/CenteredPopUp/CenteredPopUp";
import FreeTrialMarketingPopupContent from "../FreeTrials/FreeTrialMarketingPopupContent";
import FreeTrialWhatsappModal from "../FreeTrials/FreeTrialWhatsappModal";
import { connect, useDispatch } from "react-redux";
import DateRangeComponent from "../../DateRangeComponent/DateRangeComponent";
import ReportDownloadContent from "../ReportDownloadContent/ReportDownloadContent";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { getDateWithOffset, openCustomMMBURL } from "../../Values/utils";
import {
    deleteCampaign,
    fetchAllCampaigns,
  } from "../../Services/marketingAutomation";
  import { themeColors } from "../../Components/theme";
  import { useHistory } from "react-router-dom";
  import {
    upsateIsSystemMessagesActivated,
    checkOrgHasSetDispositionConfig,
  } from "../../Services/organizations";
  import { setLockSideNavbar, showSnackbarAction, setWAAgentActiveStatus, setHasActiveWAPackage } from "../../Redux/actions";
  import deleteIcon from "../../Assets/Images/delete.svg";
  import NewBroadCastFlow from "../MarketingAutomation/NewBroadCastFlow";
  import { fetchIsOrgDispositionActive } from "../../Services/marketingAutomation";
  import { isWAAgentActive, hasActiveWAPackage as callHasActiveWAPackage } from "../../Services/marketingAutomation";
  import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
  import DownloadingIcon from '@mui/icons-material/Downloading';
  import { styled } from '@mui/material/styles';
  import { pushToGA } from "../../Services/users";
import { creditHistory } from "../../Services/pgi";
import axiosHandler from "../../Services/axiosHandler";
import { url } from "../../Values/constants";

interface MarketingScreenProps{
    user: any;
    theme: any;
    isOrgDispositionActivated: boolean;
    organizationId: string;
    hasActiveWAPackage: boolean;
    WAAgentActiveStatus: string;
    initialParams: any;
    organizationData: any;
}

const MarketingScreenNew: React.FC<MarketingScreenProps> = ({
    user,
  theme,
  isOrgDispositionActivated,
  organizationId,
  hasActiveWAPackage,
  WAAgentActiveStatus,
  initialParams,
  organizationData
}) => {
    const [activeFilters, setActiveFilters] = useState<string[]>([]);
  const [onOff, setOnOff] = useState(false);
  const [openWtModel, setOpenWtModel] = useState(false);
  const [activeMarketTab, setActiveMarketTab] = useState("Broadcast Message");
  const [campaignData, setCampaignData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const pageSizeOptions = [5, 10, 25, 50];
  const history = useHistory();
  // const [isSystemMessagesActivated, setIsSystemMessagesActivated] =
  //   useState(false);
  const dispatcher = useDispatch();
  const [draftData, setDraftData] = useState({});
  const [isRefersh, setIsRefersh] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [minDate, setMinDate] = useState<Date | string>("");
  const [maxDate, setMaxDate] = useState<Date | string>("");
  // const [reportStartDate, setReportStartDate] = useState("");
  // const [reportEndDate, setReportEndDate] = useState("");
  const [submitReportRequest, setSubmitReportRequest] = useState(false);
  const [vendorMappingData, setVendorMappingData] = useState<Record<string, any>>({});
  const totalPages = Math.ceil(totalCount / pageSize) > 0 ? Math.ceil(totalCount / pageSize) : 1;
  // console.log("totalnn",totalPages);
  const isLastPage = page === totalPages;
  const [showBroadcastSlide, setShowBroadcastSlide] = useState(false);
  const [showFreeTrailPage, setShowFreeTrailPage] = useState(true);
  const [showFreeTrailPopUp, setShowFreeTrailPopUp] = useState(true);
  const [showFreeTrialWhatappComponentV1, setShowFreeTrialWhatappComponentV1] = useState(false);
  const [showFreeTrialWhatappComponentV2, setShowFreeTrialWhatappComponentV2] = useState(false);
  const [showFreeTrialModal, setShowFreeTrialModal] = useState(false);
  const [broadRates, setBroadRates] = useState("");
  const [agentModerationStatus, setAgentModerationStatus] = useState("");
  const [autoToken, setAutoToken] = React.useState("");
  const [totalBalance, setTotalBalance] = useState("")
  const soId = user?.user_super_oid;
  const [rate, setRate] = useState<any>();

  useEffect(() => {
    let userData: any = localStorage.getItem("user");
    let parsedUser = JSON.parse(userData);
    if (parsedUser.autoToken) {
      setAutoToken(parsedUser.autoToken)
    }
  }, [])

  const showBroadcastSlideOrNot = (hasActiveWAPackage: boolean) => {
    const todayDay = new Date().getDay();
    if (hasActiveWAPackage === false && user.user_email && organizationData.WhatsAppTrialPack === true) {
      let isBroadcastSlideShown: any = localStorage.getItem("lastBroadcastSlideShowTime");
      let today = new Date();
      let todayDate = today.toISOString().split('T')[0]; // Get YYYY-MM-DD format

      if (isBroadcastSlideShown) {
        // Retrieve the last shown date from local storage
        let parsedData = JSON.parse(isBroadcastSlideShown);
        let lastBroadcastSlideShowTime = new Date(parsedData.date);
        let lastBroadcastSlideShowDate = lastBroadcastSlideShowTime.toISOString().split('T')[0];
        // Check if the day has changed
        if ((lastBroadcastSlideShowDate !== todayDate) || (parsedData.user_email !== user.user_email)) {
          // Update the last shown date in local storage
          localStorage.setItem('lastBroadcastSlideShowTime', JSON.stringify({
            user_email: user.user_email,
            date: today
          }));
          // setShowBroadcastSlide(true) // Show the modal
          
    // console.log("todayDay 1111",todayDay)
          if ([0, 1, 2, 3, 4, 5, 6].includes(todayDay)) {
            setShowBroadcastSlide(false);
            // setShowFreeTrialWhatappComponentV1(false); // Tue, Sun
            setShowFreeTrialModal(true); 
            // setShowFreeTrialWhatappComponentV2(false);
          } 
        }
      } else {
        // setShowBroadcastSlide(true);
        if ([0, 1, 2, 3, 4, 5, 6].includes(todayDay)) {
          setShowBroadcastSlide(false);
          setShowFreeTrialWhatappComponentV1(false); // Tue, Sun
          setShowFreeTrialModal(true); 
          setShowFreeTrialWhatappComponentV2(false);
        } 
        localStorage.setItem("lastBroadcastSlideShowTime", JSON.stringify({
          user_email: user.user_email,
          date: today
        }));
      }
    } else {
      // setShowBroadcastSlide(false);
       if ([0, 1, 2, 3, 4, 5, 6].includes(todayDay)) {
        setShowBroadcastSlide(false);
        setShowFreeTrialWhatappComponentV1(false); // Tue, Sun
        setShowFreeTrialModal(false); 
        setShowFreeTrialWhatappComponentV2(false);
      } 
    }
  }


  const formatDate = (date: any) => {
    const options: object = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);
    return formattedDate.replace(/,/g, ""); // Remove any commas
  };


  const handleIsWAAgentActive = async (organizationId: string) => {
    let agentStatus = await isWAAgentActive(organizationId,(data: any) => setBroadRates(data), (data: string) => setAgentModerationStatus(data));
    dispatcher(setWAAgentActiveStatus({ WAAgentActiveStatus: agentStatus }));
  }

  const handleHasActiveWAPackage = async (soid: string) => {
    let waStatus = await callHasActiveWAPackage(soid);
    showBroadcastSlideOrNot(waStatus);
    dispatcher(setHasActiveWAPackage({ hasActiveWAPackage: waStatus }));
  }

  useEffect(() => {
    if (user?.uid && user?.profile) {
      pushToGA(
        "event_tracking",
        "read pro",
        "read pro",
        "page load",
        user,
      )
    }
  }, [user])

  useEffect(() => {
    const today = new Date();
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(today.getDate() - 30);
    const ninetyDaysAgo = new Date(today);
    ninetyDaysAgo.setDate(today.getDate() - 90);

    setMinDate(ninetyDaysAgo);
    setMaxDate(today);
    setStartDate(thirtyDaysAgo);
    setEndDate(today);
  }, []);

  useEffect(() => {
    fetchIsOrgDispositionActive(user.organization_id, dispatcher, setVendorMappingData);
  }, [user.organization_id]);

  useEffect(() => {
    fetchAllCampaigns(
      user.organization_id,
      page,
      pageSize,
      setCampaignData,
      setTotalCount,
      startDate,
      endDate,
      activeMarketTab
      // setDownloadHeaders,
      // setDownloadData
    );
    setIsRefersh(false)
  }, [page, pageSize, isRefersh, user.organization_id, startDate, endDate, activeMarketTab, submitReportRequest]);

  // useEffect(() => {
  //   fetchCampaignReportDateWise(
  //     user.organization_id,
  //     reportStartDate,
  //     reportEndDate,
  //     setReportData,
  //     setDownloadHeaders,
  //     setDownloadData,
  //     vendorMappingData,
  //     activeMarketTab
  //   );
  //   // setIsRefersh(false)
  // }, [reportStartDate, reportEndDate,user.organization_id, activeMarketTab,isRefersh]);

  useEffect(() => {
    if (organizationId && user.user_oid) {
      handleIsWAAgentActive(organizationId);
      handleHasActiveWAPackage(user.user_oid);
    }
  }, [organizationId, user.user_oid])

  const handleFilterClick = (filter: string) => {
    setActiveFilters((prevFilters) => {
      if (prevFilters.includes(filter)) {
        return prevFilters.filter((f) => f !== filter);
      } else {
        return [...prevFilters, filter];
      }
    });
  };

  // const handleOnOffClick = () => {
  //   setOnOff(!onOff)
  // };

  const handleSystemMessagesActivated = async (
    isSystemMessagesActivated: boolean
  ) => {
    // setIsSystemMessagesActivated(isSystemMessagesActivated);
    // let orgDispositionConfig = await 
    checkOrgHasSetDispositionConfig(organizationId).then((data) => {
      if (
        data.length === 0 &&
        isSystemMessagesActivated
      ) {
        // alert("i anan")
        history.push({
          pathname: "/marketing",
          state: {
            showSetupScreen: true,
          },
        });
        dispatcher(setLockSideNavbar({ lockSideNavbar: true }));
      }
      if (
        data.length === 0 &&
        !isSystemMessagesActivated
      ) {
        upsateIsSystemMessagesActivated(
          organizationId,
          isSystemMessagesActivated,
          dispatcher
        );
      }
      if (
        data.length > 0
      ) {
        let showSetupScreen = true;
        data.forEach((item: any) => {
          if (item.ISACTIVE == 'Y') {
            showSetupScreen = false;
          }
        })
        if (showSetupScreen && isSystemMessagesActivated) {
          history.push({
            pathname: "/marketing",
            state: {
              showSetupScreen: true,
            },
          });
          dispatcher(setLockSideNavbar({ lockSideNavbar: true }));
        } else {
          upsateIsSystemMessagesActivated(
            organizationId,
            isSystemMessagesActivated,
            dispatcher
          );
        }
      }
    })
  };

  const handleModalToggle = () => {
    setOpenWtModel(!openWtModel);
  };

  const clearFilter = () => {
    const today = new Date();
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(today.getDate() - 30);
    setStartDate(thirtyDaysAgo);
    setEndDate(today);
  };

  const buttonStyles = {
    backgroundColor: theme
      ? themeColors.buttonPrimary
      : themeColors.buttonPrimaryDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  const footerStyles = {
    backgroundColor: theme
      ? themeColors.thBackgroundColor
      : themeColors.thBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  const getRangeCallback = (range: any) => {
    setStartDate(range.startDate);
    setEndDate(range.endDate);
  }
  let path = history.location.pathname;

  useEffect(() => {
    if (path == "/marketing") {
      window.scrollTo(0, 0);
    }
  },[path])

  useEffect(() => {

    if(hasActiveWAPackage === false && showBroadcastSlide === false){
      // document.body.classList.add('no-overflow');
    }else if((hasActiveWAPackage && WAAgentActiveStatus == "In Progress")){
      document.body.classList.add('no-overflow');
    }else{
      document.body.classList.remove('no-overflow');
    }

    if (showBroadcastSlide=== false) {
      window.scrollTo(0, 100);
    }

  },[hasActiveWAPackage, showBroadcastSlide, WAAgentActiveStatus])

  const [showReportPopup, setShowReportPopup] = useState(false)

  const downloadReportHandler = () => {
    setShowReportPopup(true)
    document.body.classList.add("no-overflow");
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#f5f5f5",
      padding: "20px 16px",
      borderBottom: "1px solid #d7d7d7",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      fontWeight: 400,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
    '&:hover': {
      boxShadow: "0 2px 8px 0 rgba(0, 0, 0, .12), 0 8px 20px 0 rgba(0, 0, 0, .1)",
      background: "#fff"
    },
  }));

  useEffect(() => {
    const fetchData = async () => {
      if(soId){
        await creditHistory(["13739"], soId, (data: any) => setTotalBalance(data));
      }
    };
  
    fetchData();
  }, [soId]); // Add dependencies if needed

  const readProductList = async () => {
		const apiUrl = url + '/pgi/readProductList';

		const payload = {
			soid: user.user_super_oid,
		};

		try {
			const response = await axiosHandler.post(apiUrl, payload);
			const data = response.data;
			setRate(data.rate)
		} catch (error: any) {
			// Handle errors
			console.error('Error fetching responses:', error.response || error);
			throw error;
		}
	};
  useEffect(() => {
      if (user?.uid && user?.profile) {
        readProductList();
      }
    }, [user]);

    return(
        <>{
            showFreeTrialModal ?
            <CenteredPopUp 
                setModal={setShowFreeTrialModal}
                children={<FreeTrialWhatsappModal closePopup={setShowFreeTrialModal}/>}
                modiferClass={style.ftmModal}
                closeIcon={true}
                closeClassMofifier={style.ftmClose}
            />
            :
            showBroadcastSlide ?
                <CenteredPopUp
                  setModal={setShowBroadcastSlide}
                  children={<FreeTrialMarketingPopupContent />}
                  modiferClass={style.FtmktPopup}
                  closeIcon={true}
                  popupName="Whatsapp_Marketing"
                />
              :
              hasActiveWAPackage===true ?
                      <div className={style.Marketing}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className={style.MarketingHeading}>
                Marketing
                {
                  hasActiveWAPackage && (
                    <div className={style.MarketingStatus}>
                      Activation status
                      <span className={style.MarketingStatusCta}>{WAAgentActiveStatus}</span>
                    </div>
                  )
                }
                <div className={style.marketingLabel}>Today's WhatsApp cost <div className={style.semiBold}><span className={style.rupees}>&#8377;</span>{broadRates || "-/-"}/msg</div></div>
                <div className={style.marketingLabel}>Your Credit Balance <div className={style.semiBold}><span className={style.rupees}>&#8377;</span>{totalBalance || "-/-"}</div></div>
              </div>

              
                
                    <div>
                        <div className={style.menuText} onClick={() => {history.push("/whatsappRechargePlans",{marktopScreen:true})}}>Explore Packages</div>
                        {(hasActiveWAPackage && WAAgentActiveStatus == "Active") && ( <div className={style.menuText} onClick={() => {history.push("/templates")}}>Manage Templates</div> )}
                    </div>
               
              
            </div>

            <div className={style.MarketingWrap}>
              <div className={style.MarketingTabWrap}>
                <div
                  className={`${style.MarketingTabItem} ${activeMarketTab === "Broadcast Message" && style.Active
                    }`}
                  onClick={() => {
                    setActiveMarketTab("Broadcast Message");
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span className={style.BroadcastMessageManual}>
                      Broadcast Message
                      <span className={style.textstyle1}>(Manual)</span>
                    </span>
                    <span className={style.Messageswillbesentto}>
                      Messages will be sent to clients in bulk
                    </span>
                  </div>
                </div>

                <div
                  className={`${style.MarketingTabItem}  ${activeMarketTab === "System Triggered Messages" && style.Active
                    }`}
                  onClick={() => {
                    setActiveMarketTab("System Triggered Messages");
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span className={style.SystemTriggeredMessages}>
                      System Triggered Messages
                      <span className={style.textstyle1}>(Automatic Setup)</span>
                    </span>
                    <span className={style.Messageswillbesentautomaticallyassoon}>
                      Messages will be sent automatically as soon as the lead status
                      is changed
                    </span>
                  </div>
                </div>
              </div>

              {activeMarketTab === "System Triggered Messages" &&
                isOrgDispositionActivated === true && (
                  <div className={style.MarketingAutomaticMsg}>
                    <span className={style.MarketingAutomaticMsgIcon}></span>
                    <span className="TextBold">
                      Your clients are receiving automatic messages
                    </span>{" "}
                    on the change of their lead status. To stop you can deactivate
                    here
                    <div className={style.MarketingAutomaticMsgOnOffWrap}>
                      <>Active</>
                      <span
                        onClick={() => handleSystemMessagesActivated(false)}
                        className={`${style.MarketingAutomaticMsgOnOff} ${style.On}`}
                      ></span>
                    </div>
                  </div>
                )}

              {activeMarketTab === "System Triggered Messages" &&
                isOrgDispositionActivated !== true && (
                  <div className={style.MarketingAutomaticMsg}>
                    <span className={style.MarketingAutomaticMsgInactiveIcon}></span>
                    <span className="TextBold">
                      Your clients are not receiving automatic messages
                    </span>{" "}
                    on the change of their lead status. Toggle to activate
                    <div className={style.MarketingAutomaticMsgOnOffWrap}>
                      <>Disabled</>
                      <span
                        onClick={() => handleSystemMessagesActivated(true)}
                        className={`${style.MarketingAutomaticMsgOnOff} ${style.Off}`}
                      ></span>
                    </div>
                  </div>
                )}

              {isOrgDispositionActivated !== true &&
                activeMarketTab === "System Triggered Messages" && (
                  <div className={style.MarketingDiactivated}>
                    <div className={style.MarketingDiactivatedBlock}>
                      <div className={style.MarketingDiactivatedBlockIcon}></div>
                      <div className={style.MarketingDiactivatedBlockTitle}>
                        System triggered messages are
                        <br />
                        currently <span className="TextBold">deactivated</span>
                      </div>
                    </div>
                  </div>
                )}

              {/* Activation in Progress */}
              {
                (hasActiveWAPackage && WAAgentActiveStatus == "In Progress") && (
                  <div className={style.MarketingDiactivatedBlockLayer}>
                    <div className={style.MarketingDiactivatedBlock}>
                      <div className={style.MarketingInprogressBlockIcon}></div>
                      <div className={style.MarketingDiactivatedHeading}>Activation in Progress!</div>
                      <div className={style.MarketingDiactivatedText}>
                        Your details are being processed by WhatsApp, and we will let you know once it's completed.
                      </div>
                    </div>
                  </div>
                )
              }

                  {/* Payment Recieved */}
                  {
                    (hasActiveWAPackage && agentModerationStatus === "N") && (
                      <div className={style.MarketingDiactivatedBlockLayer}>
                        <div className={style.MarketingDiactivatedBlock}>
                          <div className={style.MarketingPaymentRecievedBlockIcon}></div>
                          <div className={style.MarketingDiactivatedHeading}>Payment Received!</div>
                          <div className={style.MarketingDiactivatedBlockTitle}>Complete your Company <br />Profile to activate marketing</div>
                          <div className={style.MarketingDiactivatedCta} style={{ cursor: "pointer" }} onClick={() => {
                            openCustomMMBURL(
                              autoToken,
                              "bricks/userRegistrationStep2.html"
                            );
                          }}>Complete Profile</div>
                        </div>
                      </div>
                    )
                  }

              {/* No Active Package */}
              {/* {
                (hasActiveWAPackage === false && showBroadcastSlide === false) && (
                  <div className={style.MarketingDiactivatedBlockLayer}>
                    <div className={style.MarketingDiactivatedBlock}>
                      <div className={style.MarketingNoActivePkgBlockIcon}></div>
                      <div className={style.MarketingDiactivatedHeading}>No Active Package</div>
                      <div className={style.MarketingDiactivatedText}>For buying package, contact your Account Manager</div>
                      <div className={style.MarketingDiactivatedText}>or</div>
                      <div className={style.MarketingDiactivatedCta} onClick={() => {
                        setShowBroadcastSlide(true);
                        pushToGA(
                          "event_tracking",
                          "read pro",
                          "read pro",
                          "Know More clicked",
                          user,
                        )
                      }}>Know More</div>
                    </div>
                  </div>
                )
              } */}

              {/* {
                (hasActiveWAPackage === false && showBroadcastSlide) && (
                  <BroadcastSlides />
                )
              } */}

              <div className={style.Frame1410120898}>
                {/* <div className={`planfilers ${style.MarketingWrapFilers}`}>
            <span
              className={`planfiltercta ${activeFilters.includes("SMS") ? "active" : ""}`}
              onClick={() => handleFilterClick("SMS")}
            >
              SMS
            </span>
            <span
              className={`planfiltercta ${activeFilters.includes("Whatsapp") ? "active" : ""}`}
              onClick={() => handleFilterClick("Whatsapp")}
            >
              Whatsapp
            </span>
            <span
              className={`planfiltercta ${activeFilters.includes("Email") ? "active" : ""}`}
              onClick={() => handleFilterClick("Email")}
            >
              Email
            </span>
          </div> */}
                <div></div>
                <div className={style.Frame1410120905}>
                  <DateRangeComponent callback={getRangeCallback} defaultStartDate={startDate} defaultEndDate={endDate} minDate={minDate} maxDate={maxDate} />
                  <div className={style.Frame208} onClick={() => { }}>
                    <span className={style.Readmore}>
                    <span style={{ color: "#279f9f" }} onClick={downloadReportHandler}>Download</span>
                      {/* {
                        (organizationId === "3rxB4vSCjKcbp3L43kk7" || organizationId === "6787bf48222aab7342781b53" || organizationId === "W5phvDYBAtopkrdehko2")
                          ?
                          <span style={{ color: "#279f9f" }} onClick={downloadReportHandler}>Download</span>
                          :
                          (downloadData && downloadData.length > 0) ? (
                            <CSVLink data={downloadData} headers={downloadHeaders} filename={`WhatsappReport${formatDate(startDate)}-${formatDate(endDate)}.csv`}>
                              <span style={{ color: "#279f9f" }}>Download</span>
                            </CSVLink>
                          ) : (
                            <span style={{ color: "#279f9f" }} onClick={() => {
                              dispatcher(showSnackbarAction(
                                "No data available to download.",
                                "warning"
                              ))
                            }}>Download</span>
                          )} */}
                      
                      {/* {downloadData && downloadData.length > 0 ? (
                        // <CSVLink data={downloadData} headers={downloadHeaders} filename={`WhatsappReport${formatDate(startDate)}-${formatDate(endDate)}.csv`}>
                        //   <span style={{ color: "#279f9f" }}>Download</span>
                        // </CSVLink>
                        <span style={{ color: "#279f9f" }} onClick={downloadReportHandler}>Download</span>
                      ) : (
                        <span style={{ color: "#279f9f" }} onClick={() => {
                          dispatcher(showSnackbarAction(
                            "No data available to download.",
                            "warning"
                          ))
                        }}>Download</span>
                      )} */}
                    </span>
                    <div className={style.Vector}></div>
                  </div>
                  {
                    showReportPopup && 
                    <CenteredPopUp
                      setModal={setShowReportPopup}
                      children={<ReportDownloadContent setShowReportPopup={setShowReportPopup} activeMarketTab={activeMarketTab} setSubmitReportRequest={setSubmitReportRequest} submitReportRequest={submitReportRequest} />}
                      modiferClass={style.ReportPopup}
                      closeIcon={true}
                    />
                  }
                  {activeMarketTab === "Broadcast Message" && (
                    <div className={style.Frame207}>
                      <span
                        className={style.Buttontext}
                        onClick={() => setOpenWtModel(true)}
                      >
                        + New Broadcast Message
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: (campaignData.length > 0) ? "100vw" : "auto" }} aria-label="Campaign Data Tabel">
                  <TableHead className={`${style.MarketingTableRow} ${style.Head}`}>
                    {
                      (activeMarketTab === "Broadcast Message") ?
                        <TableRow>
                          < StyledTableCell>Name</StyledTableCell>
                          < StyledTableCell>Message Preview</StyledTableCell>
                          < StyledTableCell>Progress</StyledTableCell>
                          {/* < StyledTableCell>Post By</StyledTableCell> */}
                          < StyledTableCell>Status</StyledTableCell>
                          < StyledTableCell>Created On</StyledTableCell>
                          < StyledTableCell>Processed On</StyledTableCell>
                          < StyledTableCell>Action</StyledTableCell>
                        </TableRow>
                        :
                        <TableRow>
                          {/* <StyledTableCell>Type</StyledTableCell> */}
                          <StyledTableCell>Stage</StyledTableCell>
                          <StyledTableCell>Sub Stage</StyledTableCell>
                          <StyledTableCell>Message Preview</StyledTableCell>
                          <StyledTableCell>Progress</StyledTableCell>
                          <StyledTableCell>Processed On</StyledTableCell>
                          <StyledTableCell>Action</StyledTableCell>
                          {/* <StyledTableCell>Reported On</StyledTableCell> */}
                        </TableRow>
                    }
                  </TableHead>
                  <TableBody>
                    {
                      campaignData.length > 0 && campaignData.map((item: any, index: any) => {
                        return activeMarketTab === "Broadcast Message" ? (
                          <StyledTableRow
                            key={index}
                          >
                            <StyledTableCell component="th" scope="row">
                              <span className="TextBold">{item.CAMPAIGN_NAME}</span>
                            </StyledTableCell>
                            <StyledTableCell>
                              <div className={style.Marketing2LineEllipsis}>
                                {item.MESSAGE_PREVIEW ? item.MESSAGE_PREVIEW : "N/A"}
                              </div>
                            </StyledTableCell>
                            <StyledTableCell>
                              <div className={style.MarketingProgress}>
                                <div className={style.MarketingProgressCol}>
                                  <div className={style.MarketingProgressTitle}>
                                    {item.MSG_SENT_COUNT}
                                  </div>
                                  <div className={style.MarketingProgressText}>Sent</div>
                                </div>
                                <div className={style.MarketingProgressCol}>
                                  <div className={style.MarketingProgressTitle}>
                                    {item.MSG_DELIEVERED_COUNT}
                                  </div>
                                  <div className={style.MarketingProgressText}>
                                    Delivered
                                  </div>
                                </div>
                                <div className={style.MarketingProgressCol}>
                                  <div className={style.MarketingProgressTitle}>
                                    {item.MSG_READ_COUNT}
                                  </div>
                                  <div className={style.MarketingProgressText}>Read</div>
                                </div>
                              </div>
                            </StyledTableCell>
                            {/* <StyledTableCell>{item.CREATEDBY}</StyledTableCell> */}
                            <StyledTableCell
                              onClick={() => {
                                if (item?.CAMPAIGN_STATUS === "Draft" || item?.CAMPAIGN_STATUS === "New") {
                                  setDraftData(item);
                                  setOpenWtModel(true);
                                }
                              }}>
                              <span
                                className={`${style.MarketingStatusIcon} ${style.Active}`}
                              ></span>
                              {(item.CAMPAIGN_STATUS == "New" || item.CAMPAIGN_STATUS == "Processing") ? "Scheduled" : item.CAMPAIGN_STATUS}
                            </StyledTableCell>
                            <StyledTableCell>{getDateWithOffset(item.CREATEDATE, "dateAndTime")}</StyledTableCell>
                            <StyledTableCell>{item.SCHEDULED_AT ? getDateWithOffset(item.SCHEDULED_AT, "dateAndTime", true) : getDateWithOffset(item.MODIDATE, "dateAndTime")}
                              {/* {getDateWithOffset(item.MODIDATE, "dateAndTime")} */}
                            </StyledTableCell>
                            <StyledTableCell>
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <img onClick={async () => {
                                  const res = await deleteCampaign(user, item);
                                  if (res?.success === false) {
                                    dispatcher(showSnackbarAction(res?.message, "error"));
                                  } else {
                                    dispatcher(showSnackbarAction(res?.message, "success"));
                                  }
                                  setIsRefersh(true)
                                }} src={deleteIcon} style={{ paddingLeft: "1rem" }} />
                                {
                                  (item.CURRENT_STATUS && (item.CURRENT_STATUS === "REQUESTED" || item.CURRENT_STATUS === "PROCESSING")) &&
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      dispatcher(showSnackbarAction("Your request is under process, report will be available soon.", "warning"));
                                    }}
                                  >
                                    <DownloadingIcon />
                                  </div>
                                }
                                {
                                  (item.CURRENT_STATUS && item.CURRENT_STATUS === "PROCESSED") &&
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      window.open(item.S3URL, "_blank")
                                      // dispatcher(showSnackbarAction("Your request is under process.", "warning"));
                                    }}
                                  >
                                    <CloudDownloadIcon />
                                  </div>
                                }
                              </div>
                            </StyledTableCell>
                          </StyledTableRow>
                        ) :
                          (
                            <StyledTableRow key={index}>
                              <StyledTableCell component="th" scope="row">
                                <span className="TextBold">{item.DISPOSITION}</span>
                              </StyledTableCell>
                              <StyledTableCell>
                                <span className="TextBold">{item.SUB_DISPOSITION}</span>
                              </StyledTableCell>
                              <StyledTableCell>
                                <div className={style.Marketing2LineEllipsis}>
                                  {item.MESSAGE_PREVIEW ? item.MESSAGE_PREVIEW : "N/A"}
                                </div>
                              </StyledTableCell>
                              <StyledTableCell>
                                <div className={style.MarketingProgress}>
                                  <div className={style.MarketingProgressCol}>
                                    <div className={style.MarketingProgressTitle}>
                                      {item.MSG_SENT_COUNT}
                                    </div>
                                    <div className={style.MarketingProgressText}>Sent</div>
                                  </div>
                                  <div className={style.MarketingProgressCol}>
                                    <div className={style.MarketingProgressTitle}>
                                      {item.MSG_DELIEVERED_COUNT}
                                    </div>
                                    <div className={style.MarketingProgressText}>
                                      Delivered
                                    </div>
                                  </div>
                                  <div className={style.MarketingProgressCol}>
                                    <div className={style.MarketingProgressTitle}>
                                      {item.MSG_READ_COUNT}
                                    </div>
                                    <div className={style.MarketingProgressText}>Read</div>
                                  </div>
                                </div>
                              </StyledTableCell>
                              {/* <StyledTableCell>
                                {item.CREATEDBY}
                              </StyledTableCell> */}
                              {/* <StyledTableCell>
                                {getDateWithOffset(item.CREATEDATE, "dateAndTime")}
                              </StyledTableCell> */}
                              <StyledTableCell>
                                {getDateWithOffset(item.REPORT_DATE, "onlyDate")}
                              </StyledTableCell>
                              <StyledTableCell>
                                <div
                                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                >
                                  {
                                    (item.CURRENT_STATUS && (item.CURRENT_STATUS === "REQUESTED" || item.CURRENT_STATUS === "PROCESSING")) &&
                                    <div
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        dispatcher(showSnackbarAction("Your request is under process, report will be available soon.", "warning"));
                                      }}
                                    >
                                      <DownloadingIcon />
                                    </div>
                                  }
                                  {
                                    (item.CURRENT_STATUS && item.CURRENT_STATUS === "PROCESSED") &&
                                    <div
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        window.open(item.S3URL, "_blank")
                                        // dispatcher(showSnackbarAction("Your request is under process.", "warning"));
                                      }}
                                    >
                                      <CloudDownloadIcon />
                                    </div>
                                  }
                                </div>
                              </StyledTableCell>
                            </StyledTableRow>
                          )
                      })
                    }
                  </TableBody>
                </Table>
                { !(campaignData.length > 0 ) &&
                    <div className={style.NoData}>
                    <h2>No Data Available</h2>
                  </div>
                  }
              </TableContainer>
              
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                  borderRadius: " 0.5rem",
                  padding: "0.5rem",
                  marginTop: "1rem",
                  marginBottom: "-1rem",
                  ...footerStyles,
                }}
              >
                <div className={style.footer_table}>
                  <div style={{ marginLeft: "20px" }}>
                    <button
                      className={style.clearFilter}
                      style={buttonStyles}
                      // style={
                      //   location.state?.detail || localStorage.length > 0
                      //     ? { color: '#fff', borderColor: '#fff' }
                      //     : { color: '#555', borderColor: '#555' }
                      // }
                      onClick={() => clearFilter()}
                    >
                      Clear Filter
                    </button>
                  </div>
                  <div>
                    <span>
                      Page <strong>{page}</strong>
                    </span>
                    <select
                      className={style.dropDownSelecct}
                      value={pageSize}
                      onChange={(e) => {
                        setPageSize(Number(e.target.value));
                      }}
                    >
                      {pageSizeOptions.map((pagesize) => (
                        <option key={pagesize} value={pagesize}>
                          Show {pagesize}
                        </option>
                      ))}
                    </select>
                    <button
                      className={style.addBox}
                      onClick={() => {
                        // setLastPage(1000)
                        // setChecked(false);
                        if (page !== 0) {
                          setPage(page - 1);
                        }
                      }}
                      style={page === 1 ? { backgroundColor: "#ced4da" } : {}}
                      disabled={page === 1 ? true : false}
                    >
                      Previous
                    </button>
                    <button
                      className={style.addBox}
                      onClick={async () => {
                        // setChecked(false);
                        setPage(page + 1);
                      }}
                      style={isLastPage ? { backgroundColor: "#ced4da" } : {}}
                      disabled={isLastPage ? true : false}
                    >
                      Next
                    </button>
                  </div>
                  {/* <div>
          <p className={style.countHead}>Selected Records: </p>
        </div> */}
                  <div>
                    <p style={{ marginRight: "20px" }} className={style.countHead}>
                      Total Records: {totalCount}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {openWtModel && (
              // <NewWhatsappBroadcast
              //   onClose={() => {
              //     setOpenWtModel(false);
              //   }}
              //   draftData={draftData}
              // />
              <NewBroadCastFlow
                onClose={() => {
                  setOpenWtModel(false);
                  setDraftData({})
                }}
                draftData={draftData}
                setIsRefersh={setIsRefersh}
              />
            )}
          </div>
        : 
              <div className={styles.Marketing}>
                <MarketingScreenBanner history={history} />
                <MarketingWhyReadProWhatsapp />
                <div className={styles.BusinessPlans}>
                  <div className={styles.BusinessPlansHeading}>Plans for every business size <div className={styles.BusinessPlansOffer}>GET <span className={styles.Rupees}>&#8377;</span>500 WELCOME BONUS</div></div>
                  <MarketingBussinessPlans />
                </div>
                <MarketingTestimonials />
                <FaqLayout deviceCheck={true} data={whatsappMarketingFaqs} isNote={true} rate={rate} />
              </div>
        }</>
    )
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    organizationData: state.organization.organizationData,
    organizationId: state.organization.id,
    hasActiveWAPackage: state.organization.hasActiveWAPackage,
    WAAgentActiveStatus: state.organization.WAAgentActiveStatus,
    isOrgDispositionActivated: state.marketingAutomationData.isSystemMessagesActivated,
    initialParams:state.utils.initialParams,
  };
};

export default connect(mapStateToProps)(MarketingScreenNew);

// export default MarketingScreenNew;